const directives = {
  fixed: {
    // inserted 被绑定元素插入父节点时调用
    inserted () {
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      document.body.style.cssText += 'position:fixed;width:100%;top:-' + scrollTop + 'px;'
    },
    // unbind 指令与元素解绑时调用
    unbind () {
      const body = document.body
      const top = body.style.top
      body.style.position = ''
      document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top)
      body.style.top = ''
    }
  }
}

export default directives
